var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStadium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 325.084,
    x2: 340.371,
    y1: 73.524,
    y2: 105.463
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff7044"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f82814"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.956,
    x2: 299.702,
    y1: 91.451,
    y2: 86.264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f82814",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6245,
    stopColor: "#d22725",
    stopOpacity: 0.625
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0272d"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8f6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#efdcfb"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 293.407,
    x2: 307.536,
    xlinkHref: "#lg1",
    y1: 113.841,
    y2: 113.841
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4856,
    stopColor: "#baaad6",
    stopOpacity: 0.486
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8679b2"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 304.163,
    x2: 299.198,
    xlinkHref: "#lg2",
    y1: 79.748,
    y2: 58.002
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 301.058,
    x2: 301.058,
    xlinkHref: "#lg1",
    y1: 60.817,
    y2: 67.332
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bada00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2187,
    stopColor: "#b6d600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4501,
    stopColor: "#acc900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6873,
    stopColor: "#9ab400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9271,
    stopColor: "#829700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798c00"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.288,
    x2: 441.575,
    xlinkHref: "#lg3",
    y1: 96.819,
    y2: 128.758
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 429.16,
    x2: 400.906,
    y1: 114.745,
    y2: 109.559
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a6313",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3766,
    stopColor: "#5a6216",
    stopOpacity: 0.377
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6138,
    stopColor: "#595e1e",
    stopOpacity: 0.614
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8118,
    stopColor: "#57582d",
    stopOpacity: 0.812
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9882,
    stopColor: "#545041",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#544f43"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 394.612,
    x2: 408.74,
    xlinkHref: "#lg1",
    y1: 137.136,
    y2: 137.136
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 405.367,
    x2: 400.402,
    xlinkHref: "#lg2",
    y1: 103.043,
    y2: 81.297
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.263,
    x2: 402.263,
    xlinkHref: "#lg1",
    y1: 84.112,
    y2: 90.626
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 122.675,
    x2: 137.962,
    y1: 96.819,
    y2: 128.757
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3043,
    stopColor: "#ffcd3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8558,
    stopColor: "#ffad2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa325"
  }))), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.707,
    x2: 87.397,
    y1: 114.593,
    y2: 108.041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e87264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6519,
    stopColor: "#f67150",
    stopOpacity: 0.652
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  }))), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 90.999,
    x2: 105.127,
    xlinkHref: "#lg1",
    y1: 137.136,
    y2: 137.136
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 101.755,
    x2: 96.789,
    xlinkHref: "#lg2",
    y1: 103.043,
    y2: 81.297
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.65,
    x2: 98.65,
    xlinkHref: "#lg1",
    y1: 84.112,
    y2: 90.626
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.879,
    x2: 239.166,
    y1: 73.524,
    y2: 105.463
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cefb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a97f6"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.751,
    x2: 198.498,
    y1: 91.451,
    y2: 86.264
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a97f6",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bb"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.203,
    x2: 206.332,
    xlinkHref: "#lg1",
    y1: 113.841,
    y2: 113.841
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.959,
    x2: 197.993,
    xlinkHref: "#lg2",
    y1: 79.748,
    y2: 58.002
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 199.854,
    x2: 199.854,
    xlinkHref: "#lg1",
    y1: 60.817,
    y2: 67.332
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 7.115,
    x2: 502.885,
    xlinkHref: "#lg1",
    y1: 304.191,
    y2: 304.191
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 234.253,
    x2: 280.808,
    xlinkHref: "#lg1",
    y1: 304.2,
    y2: 304.2
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.274,
    x2: 154.215,
    xlinkHref: "#lg1",
    y1: 320.486,
    y2: 313.389
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 354.384,
    x2: 394.785,
    xlinkHref: "#lg1",
    y1: 312.835,
    y2: 324.3
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 261.125,
    x2: 226.912,
    xlinkHref: "#lg2",
    y1: 267.904,
    y2: 131.777
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 151,
    y2: 320.434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#efdcfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4428,
    stopColor: "#c1aec7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8a7889"
  }))), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e566e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    stopColor: "#674d66",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#593b56"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 232,
    y2: 57.302
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.994,
    x2: 254.994,
    xlinkHref: "#lg2",
    y1: 391.856,
    y2: 351.455
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 337.563,
    x2: 199.98,
    xlinkHref: "#lg1",
    y1: 417.872,
    y2: 394.942
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8a7889"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6e566e"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 316.002,
    x2: 214.349,
    xlinkHref: "#lg5",
    y1: 414.279,
    y2: 397.337
  })), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 271.59,
    x2: 238.559,
    xlinkHref: "#lg4",
    y1: 403.683,
    y2: 395.766
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg1",
    y1: 319.789,
    y2: 362.374
  })), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 257.184,
    x2: 257.184,
    xlinkHref: "#lg5",
    y1: 434.441,
    y2: 459.933
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.107,
    x2: 170.375,
    xlinkHref: "#lg1",
    y1: 290.213,
    y2: 237.481
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 214.329,
    x2: 178.115,
    xlinkHref: "#lg5",
    y1: 281.435,
    y2: 245.221
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(.941 -.339 .339 .941 -145.587 -312.625)",
    gradientUnits: "userSpaceOnUse",
    x1: 29.228,
    x2: -23.505,
    xlinkHref: "#lg1",
    y1: 670.515,
    y2: 617.783
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(.941 -.339 .339 .941 -145.587 -312.625)",
    gradientUnits: "userSpaceOnUse",
    x1: 20.449,
    x2: -15.765,
    xlinkHref: "#lg5",
    y1: 661.736,
    y2: 625.523
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 455.041,
    x2: 424.467,
    xlinkHref: "#lg1",
    y1: 325.52,
    y2: 260.551
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientUnits: "userSpaceOnUse",
    x1: 447.905,
    x2: 432.254,
    xlinkHref: "#lg5",
    y1: 315.442,
    y2: 273.221
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientUnits: "userSpaceOnUse",
    x1: 342.94,
    x2: 290.208,
    xlinkHref: "#lg1",
    y1: 290.213,
    y2: 237.481
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 334.162,
    x2: 297.948,
    xlinkHref: "#lg5",
    y1: 281.435,
    y2: 245.221
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.77,
    x2: 84.366,
    xlinkHref: "#lg3",
    y1: 381.706,
    y2: 467.604
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 432.414,
    x2: 472.083,
    xlinkHref: "#lg3",
    y1: 398.385,
    y2: 484.216
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 389.048,
    x2: 404.335,
    y1: 422.456,
    y2: 468.317
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bada00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.202,
    stopColor: "#b3d100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.529,
    stopColor: "#9fb900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#7e9300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#798c00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m354.64 88.929c-.642-1.248-.642-2.719 0-3.966 1.866-3.625 5.62-11.423 6.234-16.599.09-.757-.44-1.46-1.19-1.603-19.808-3.761-37.26 4.54-57.143.258v39.855c19.673 4.238 36.967-3.845 56.519-.373.995.177 1.875-.698 1.71-1.696-.849-5.153-4.349-12.416-6.13-15.876z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m310.426 68.121s-.003-.003-.003-.003c-2.591-.181-5.213-.523-7.881-1.098v39.855c15.863 3.417 30.179-1.173 45.378-1.26z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m303.948 178.33h-5.78c-3.676 0-6.657-2.98-6.657-6.657v-112.774c0-5.273 4.274-9.547 9.547-9.547 5.273 0 9.547 4.274 9.547 9.547v112.774c0 3.676-2.98 6.657-6.657 6.657z",
    fill: "url(#SVGID_3_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m291.512 68.034 19.093 19.094v-22.858h-19.093z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m288.902 61.946v4.052c0 .927.596 1.717 1.412 1.876 3.165.62 6.833.974 10.745.974s7.58-.355 10.745-.974c.815-.16 1.412-.949 1.412-1.876v-4.052c0-1.173-.937-2.067-1.971-1.878-3.035.554-6.502.869-10.186.869s-7.151-.315-10.186-.869c-1.034-.189-1.971.705-1.971 1.878z",
    fill: "url(#SVGID_5_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m455.844 112.223c-.642-1.248-.642-2.719 0-3.966 1.866-3.625 5.62-11.423 6.234-16.599.09-.757-.44-1.46-1.19-1.603-19.808-3.761-37.26 4.54-57.143.258v39.855c19.673 4.238 36.967-3.845 56.519-.373.995.177 1.875-.698 1.71-1.696-.848-5.153-4.349-12.415-6.13-15.876z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m411.63 91.415s-.003-.003-.003-.003c-2.591-.181-5.213-.523-7.881-1.098v39.855c15.863 3.417 30.179-1.173 45.378-1.26z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m405.153 201.624h-5.78c-3.676 0-6.657-2.98-6.657-6.657v-112.773c0-5.273 4.274-9.547 9.547-9.547 5.273 0 9.547 4.274 9.547 9.547v112.774c-.001 3.676-2.981 6.656-6.657 6.656z",
    fill: "url(#SVGID_8_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m392.716 91.328 19.093 19.094v-22.858h-19.093z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m390.106 85.241v4.052c0 .927.596 1.717 1.412 1.876 3.165.62 6.833.974 10.745.974s7.58-.355 10.745-.974c.815-.16 1.412-.949 1.412-1.876v-4.052c0-1.173-.937-2.067-1.971-1.878-3.035.554-6.502.869-10.186.869s-7.151-.315-10.186-.869c-1.034-.19-1.971.705-1.971 1.878z",
    fill: "url(#SVGID_10_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m152.231 112.223c-.642-1.248-.642-2.719 0-3.966 1.866-3.625 5.62-11.423 6.234-16.599.09-.757-.44-1.46-1.19-1.603-19.808-3.761-37.26 4.54-57.143.258v39.855c19.673 4.238 36.967-3.845 56.519-.373.995.177 1.875-.698 1.71-1.696-.848-5.153-4.349-12.415-6.13-15.876z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m108.017 91.415-.003-.003c-2.591-.181-5.213-.523-7.881-1.098v39.855c15.863 3.417 30.179-1.173 45.378-1.26z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m101.54 201.624h-5.78c-3.676 0-6.657-2.98-6.657-6.657v-112.773c0-5.273 4.274-9.547 9.547-9.547 5.273 0 9.547 4.274 9.547 9.547v112.774c0 3.676-2.981 6.656-6.657 6.656z",
    fill: "url(#SVGID_13_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m89.103 91.328 19.094 19.094v-22.858h-19.094z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.493 85.241v4.052c0 .927.596 1.717 1.412 1.876 3.165.62 6.833.974 10.745.974s7.58-.355 10.745-.974c.815-.16 1.412-.949 1.412-1.876v-4.052c0-1.173-.937-2.067-1.971-1.878-3.035.554-6.502.869-10.186.869s-7.151-.315-10.186-.869c-1.033-.19-1.971.705-1.971 1.878z",
    fill: "url(#SVGID_15_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m253.436 88.929c-.642-1.248-.642-2.719 0-3.966 1.866-3.625 5.62-11.423 6.234-16.599.09-.757-.44-1.46-1.19-1.603-19.808-3.761-37.26 4.54-57.143.258v39.855c19.673 4.238 36.967-3.845 56.519-.373.995.177 1.875-.698 1.71-1.696-.849-5.153-4.35-12.416-6.13-15.876z",
    fill: "url(#SVGID_16_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m209.221 68.121s-.003-.003-.003-.003c-2.591-.181-5.213-.523-7.881-1.098v39.855c15.863 3.417 30.179-1.173 45.378-1.26z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m202.744 178.33h-5.78c-3.676 0-6.657-2.98-6.657-6.657v-112.774c0-5.273 4.274-9.547 9.547-9.547 5.273 0 9.547 4.274 9.547 9.547v112.774c0 3.676-2.98 6.657-6.657 6.657z",
    fill: "url(#SVGID_18_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m190.307 68.034 19.094 19.094v-22.858h-19.094z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m187.698 61.946v4.052c0 .927.596 1.717 1.412 1.876 3.165.62 6.833.974 10.745.974s7.58-.355 10.745-.974c.815-.16 1.412-.949 1.412-1.876v-4.052c0-1.173-.937-2.067-1.971-1.878-3.035.554-6.502.869-10.186.869s-7.151-.315-10.186-.869c-1.034-.189-1.971.705-1.971 1.878z",
    fill: "url(#SVGID_20_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m397.354 449.221 103.366-196.933c4.585-8.734 1.678-19.577-6.732-24.732-148.709-91.152-329.058-91.193-477.796-.118-8.487 5.197-11.55 16.04-6.925 24.852l103.366 196.932z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m235.709 449.221h38.581v-289.625c-12.856-.557-25.726-.557-38.581 0z",
    fill: "url(#SVGID_22_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m179.133 449.226h-26.348l-68.399-256.352c13.54-5.525 27.244-10.373 41.078-14.545z",
    fill: "url(#SVGID_23_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m425.624 192.885-68.409 256.341h-26.337l53.657-270.896c13.835 4.16 27.55 9.019 41.089 14.555z",
    fill: "url(#SVGID_24_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m500.716 252.286-103.362 196.94h-198.184l-182.101-182.09-7.796-14.85c-4.63-8.812-1.572-19.655 6.923-24.852 148.731-91.067 329.085-91.034 477.794.12 8.408 5.154 11.312 15.996 6.726 24.732z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m507.073 257.05c5.524-9.415 3.028-21.505-5.8-27.926-149.091-108.425-343.454-108.426-492.546 0-8.829 6.42-11.324 18.51-5.8 27.926 6.101 10.399 19.583 13.582 29.778 7.146 137.402-86.744 307.19-86.743 444.591 0 10.194 6.436 23.676 3.253 29.777-7.146z",
    fill: "url(#SVGID_26_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.727 258.247c-1.08.785-2.061 1.657-2.949 2.597 6.833 7.277 18.105 8.921 26.926 3.353 137.402-86.744 307.19-86.743 444.591 0 8.821 5.569 20.094 3.924 26.926-3.353-.887-.939-1.869-1.812-2.949-2.597-149.09-108.426-343.453-108.427-492.545 0z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m65.279 359.003 47.354 90.218h284.721l47.354-90.218z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m202.587 359.003h104.825v90.218h-104.825z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m218.238 359.003h73.523v90.218h-73.523z",
    fill: "url(#SVGID_30_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 359.003h36.762v90.218h-36.762z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.997 369.493c4.653 7.93 13.863 11.965 22.85 10.025 46.195-9.967 104.616-15.922 168.153-15.922s121.958 5.954 168.153 15.922c8.987 1.939 18.197-2.095 22.85-10.025 7.263-12.379.451-28.278-13.535-31.499-51.198-11.789-112.101-18.629-177.468-18.629s-126.27 6.841-177.468 18.629c-13.986 3.221-20.798 19.12-13.535 31.499z",
    fill: "url(#SVGID_32_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m408.416 460.647h-302.464c-5.126 0-9.281-4.155-9.281-9.281v-8.735c0-5.126 4.155-9.281 9.281-9.281h302.464c5.126 0 9.281 4.155 9.281 9.281v8.735c0 5.126-4.155 9.281-9.281 9.281z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m200.649 284.847h-11.13c-7.025 0-12.72-5.695-12.72-12.72v-19.875c0-7.025 5.695-12.72 12.72-12.72h11.13c7.025 0 12.72 5.695 12.72 12.72v19.875c0 7.025-5.695 12.72-12.72 12.72z",
    fill: "url(#SVGID_34_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m198.905 277.75h-7.643c-4.824 0-8.735-3.911-8.735-8.735v-13.649c0-4.824 3.911-8.735 8.735-8.735h7.643c4.824 0 8.735 3.911 8.735 8.735v13.649c.001 4.824-3.91 8.735-8.735 8.735z",
    fill: "url(#SVGID_35_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m86.076 310.914-10.472 3.77c-6.61 2.379-13.897-1.05-16.277-7.66l-6.732-18.7c-2.379-6.61 1.05-13.897 7.66-16.277l10.472-3.77c6.61-2.379 13.897 1.05 16.277 7.66l6.732 18.7c2.379 6.61-1.05 13.897-7.66 16.277z",
    fill: "url(#SVGID_36_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.032 304.826-7.192 2.589c-4.539 1.634-9.544-.721-11.178-5.26l-4.623-12.842c-1.634-4.539.721-9.544 5.26-11.178l7.192-2.589c4.539-1.634 9.544.721 11.178 5.26l4.623 12.842c1.634 4.54-.721 9.544-5.26 11.178z",
    fill: "url(#SVGID_37_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m426.112 310.914 10.472 3.77c6.61 2.379 13.897-1.05 16.277-7.66l6.732-18.7c2.379-6.61-1.05-13.897-7.66-16.277l-10.472-3.77c-6.61-2.379-13.897 1.05-16.277 7.66l-6.732 18.7c-2.379 6.61 1.05 13.897 7.66 16.277z",
    fill: "url(#SVGID_38_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.156 304.826 7.192 2.589c4.539 1.634 9.544-.721 11.178-5.26l4.623-12.842c1.634-4.539-.721-9.544-5.26-11.178l-7.192-2.589c-4.539-1.634-9.544.721-11.178 5.26l-4.623 12.842c-1.634 4.54.721 9.544 5.26 11.178z",
    fill: "url(#SVGID_39_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m320.481 284.847h-11.13c-7.025 0-12.72-5.695-12.72-12.72v-19.875c0-7.025 5.695-12.72 12.72-12.72h11.13c7.025 0 12.72 5.695 12.72 12.72v19.875c0 7.025-5.695 12.72-12.72 12.72z",
    fill: "url(#SVGID_40_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m318.738 277.75h-7.643c-4.824 0-8.735-3.911-8.735-8.735v-13.649c0-4.824 3.911-8.735 8.735-8.735h7.643c4.824 0 8.735 3.911 8.735 8.735v13.649c.001 4.824-3.91 8.735-8.735 8.735z",
    fill: "url(#SVGID_41_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m120.112 460.647h-99.204c-11.253 0-20.375-9.122-20.375-20.375v-9.52c0-33.021 26.769-59.789 59.789-59.789 33.021 0 59.789 26.769 59.789 59.789v29.895z",
    fill: "url(#SVGID_42_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m393.626 460.647h96.103c10.901 0 19.738-8.837 19.738-19.738v-9.222c0-31.989-25.932-57.921-57.921-57.921-31.989 0-57.921 25.932-57.921 57.921v28.96z",
    fill: "url(#SVGID_43_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m360.322 460.647h61.94c7.026 0 12.722-5.696 12.722-12.722v-5.944c0-20.617-16.714-37.331-37.331-37.331-20.617 0-37.331 16.714-37.331 37.331z",
    fill: "url(#SVGID_44_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStadium);
export default __webpack_public_path__ + "static/media/icon-stadium.0c6fa87b60c1742a5f476d15f0addfaf.svg";
export { ForwardRef as ReactComponent };